import { createContext, ReactNode } from 'react';
import { ConfirmDialogProps } from './ConfirmDialog';

export interface ConfirmDialogInfo extends Omit<ConfirmDialogProps, 'open'> {
  confirmDialogChildren?: ReactNode;
}

export type ConfirmDialogStateType = {
  showConfirmDialog: (confirmDialogInfo: ConfirmDialogInfo) => void;
};

const defaultConfirmDialogState = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showConfirmDialog: (confirmDialogInfo: ConfirmDialogInfo) => {
    // do nothing
  },
};

const ConfirmDialogStateContext = createContext<ConfirmDialogStateType>(defaultConfirmDialogState);
export default ConfirmDialogStateContext;
